import { motion } from "motion/react";

interface LobsterIconProps {
  className?: string;
}

export function LobsterIcon({ className = "w-12 h-12" }: LobsterIconProps) {
  return (
    <motion.svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      whileHover={{ scale: 1.1, rotate: 5 }}
    >
      <path
        d="M12 2C12 2 15 5 15 8C15 11 12 14 12 14C12 14 9 11 9 8C9 5 12 2 12 2Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12 14V20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 20L10 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 20L14 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15 8C17 6 20 5 21 7C22 9 20 11 18 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9 8C7 6 4 5 3 7C2 9 4 11 6 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 16L16 15" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
      <path d="M12 17L16 17" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
      <path d="M12 18L16 19" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
      <path d="M12 16L8 15" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
      <path d="M12 17L8 17" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
      <path d="M12 18L8 19" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
    </motion.svg>
  );
}
